/*
 * @FilePath: \uni-preset-vue-vite\src\utils\common.js
 * @Date: 2022-10-02 00:01:59
 * @Author: itmanyong@gmail.com
 * @LastEditors: guoye
 * @LastEditTime: 2025-08-11 14:52:52
 * @Description:
 */

import md5 from 'md5'

const { warning, success } = useToast()
/**
 * 判断对象是否为Promise
 * @param {any} obj 判断对象
 * @returns boolean
 */
function isPromise(obj) {
  if (!obj) return false
  // 如果为函数
  if (typeof obj === 'function') {
    // 兼容()=>new Promise()
    if (typeof obj.__proto__ === 'function') {
      return obj.toString().indexOf('Promise') > -1
    }
    return obj.__proto__.constructor.name === 'AsyncFunction'
  }
  // 如果为对象
  if (typeof obj === 'object') {
    return obj.__proto__.constructor.name === 'Promise'
  }
  return false
}
/**
 * 将 vite 的原始环境变量转成正确的类型
 * @param env 原始的 vite 环境变量
 * @returns 转换成正确类型的 vite 环境变量
 */
function useEnv(envConf = import.meta.env) {
  return Object.keys(envConf).reduce((acc, cur) => {
    acc[cur] = envConf[cur]
    if (['true', 'false'].includes(envConf[cur]) || [/^(\-|\+)?\d+(\.\d+)?$/].some((reg) => reg.test(envConf[cur]))) {
      acc[cur] = JSON.parse(envConf[cur])
    }

    return acc
  }, {})
}

/**
 * 加工版本定时器
 * @param {Number} ms 间隔毫秒数
 * @param {Function} callback 执行函数
 */
function interval(ms, callback, ...rest) {
  const start = document.timeline ? document.timeline.currentTime : performance.now() //定时器开始时间
  // 定时器执行函数
  function timer1(time) {
    const gaps = time - start
    const seconds = Math.round(gaps / ms) // 第几次执行
    const isStop = callback(seconds, ...rest) // 返回true表示不再继续执行
    if (isStop === true) return
    const targetNext = (seconds + 1) * ms + start // 算出下次interval开始的时间
    const delay = document.timeline ? document.timeline.currentTime : performance.now() // 取出更新完UI的时间
    setTimeout(
      () => requestAnimationFrame(timer1),
      targetNext - delay, // 算出距离下次interval开始时间
    )
  }
  // 首次触发
  timer1(start)
}

const getLabel = function (val, list, isString = true) {
  if (!(list && list.length)) return '-'
  //   console.log(103, val, list)
  val = isString ? val : Number(val)
  let arr = list.filter((e) => {
    e.id = isString ? e.id : Number(e.id)
    return val === e.id
  })
  //   console.log(82, 'arr-->', arr)
  if (arr.length === 0) return '-'
  //   console.log(82, 'arr-->', arr)
  if (arr.length) {
    return arr[0]?.name
  }
}

function keepTwoDecimalFull(num, type, bit) {
  // num值  type 输出int类型  bit 保留多少位小数
  //保留两位小数
  var result = parseFloat(num)
  if (isNaN(result)) {
    //  console.log('传递参数错误，请检查！')
    return false
  }
  result = Math.round(num * 100) / 100
  var s_x = result.toString()
  var pos_decimal = s_x.indexOf('.')
  if (pos_decimal < 0) {
    pos_decimal = s_x.length
    s_x += '.'
  }
  //   默认保留2位
  while (s_x.length <= pos_decimal + (bit ? bit : 2)) {
    s_x += '0'
  }
  if (type === 'number') {
    s_x = parseFloat(s_x)
  }
  return s_x
}

const getMd5Val = (val, k) => {
  let key = k ? k : ''
  //   console.log(116, 'key-->', key)
  return md5(val)
}

// 表单 carch 提示处理
const getFormErrorMsg = (errors) => {
  let tipMsg = errors.reduce((previous, current, index) => {
    let str
    if (index == errors.length - 1) {
      str = previous + current.message
    } else {
      str = previous + current.message + ','
    }
    return str
  }, '')
  //   console.log(77, 'tipMsg-->', tipMsg)s
  warning({ message: tipMsg })
}

// params 转 query 参数
const objToUrl = (url, obj) => {
  const tempArray = []
  for (const item in obj) {
    if (item) {
      tempArray.push(`${item}=${obj[item]}`)
    }
  }
  return `${url}?${tempArray.join('&')}`
  // return `https://www.xxx.com/xxx?${tempArray.join('&')}`
  //  https://www.xxx.com/xxx?abc=1&type=2
}

// 复制 兼容 h5
// dom写法: <span class="copy_txt" @click="copy('复制的内容11')">复制</span>
function copy(info) {
  let result
  let textarea = document.createElement('textarea')
  textarea.value = info
  textarea.readOnly = 'readOnly'
  document.body.appendChild(textarea)
  textarea.select() // 选中文本内容
  textarea.setSelectionRange(0, info.length) // 设置选定区的开始和结束点
  uni.showToast({
    //提示
    title: '复制成功',
  })
  result = document.execCommand('copy') //将当前选中区复制到剪贴板
  textarea.remove()
}

function urlToObj(url) {
  const obj = {}
  if (url) {
    const params = url?.split('?')[1]?.split('&')
    params?.map((item) => (obj[item.split('=')[0]] = item.split('=')[1]))
  }
  return obj
  // {abc: '1', type: '2'}
}

const formatDate = function (date, format) {
  if (!date) {
    return ''
  }

  let d = new Date(date)

  // 年
  if (/YYYY/.test(format)) {
    format = format.replace(/YYYY/, d.getFullYear())
  }
  // 月份
  let month = d.getMonth() + 1
  if (/MM/.test(format)) {
    let monthStr = month < 10 ? '0' + month : month
    format = format.replace(/MM/, monthStr)
  } else if (/M/.test(format)) {
    format = format.replace(/M/, month)
  }
  // 日期
  let dates = d.getDate()
  if (/DD/.test(format)) {
    let dateStr = dates < 10 ? '0' + dates : dates
    format = format.replace(/DD/, dateStr)
  } else if (/D/.test(format)) {
    format = format.replace(/D/, dates)
  }
  // 小时
  let hours = d.getHours()
  if (/HH/.test(format)) {
    let hoursStr = hours < 10 ? '0' + hours : hours
    format = format.replace(/HH/, hoursStr)
  } else if (/H/.test(format)) {
    format = format.replace(/H/, hours)
  } else if (/hh/.test(format)) {
    let hoursMin = hours > 12 ? hours - 12 : hours
    let hoursStr = hoursMin < 10 ? '0' + hoursMin : hoursMin
    format = format.replace(/hh/, hoursStr)
  } else if (/h/.test(format)) {
    let hoursMin = hours > 12 ? hours - 12 : hours
    format = format.replace(/h/, hoursMin)
  }
  // 分
  let minutes = d.getMinutes()
  if (/mm/.test(format)) {
    let minutesStr = minutes < 10 ? '0' + minutes : minutes
    format = format.replace(/mm/, minutesStr)
  } else if (/m/.test(format)) {
    format = format.replace(/m/, minutes)
  }
  // 秒
  let seconds = d.getSeconds()
  if (/ss/.test(format)) {
    let secondsStr = seconds < 10 ? '0' + seconds : seconds
    format = format.replace(/ss/, secondsStr)
  } else if (/s/.test(format)) {
    format = format.replace(/s/, seconds)
  }
  return format
}

function getDecryptSm2(data) {
  // console.log(239, 'data-->>>', data)
  let temp = {}
  for (const key in data) {
    if (data[key]) {
      temp[key] = Decrypt.sm2(data[key])
    }
  }
  return temp
}
/**
 * 生成一个可控制透明度的rgba颜色值
 * @param {Number} opacity 透明度
 * @returns String
 */
function randomRgbaColor(opacity = 1) {
  return `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(
    Math.random() * 255,
  )}, ${opacity})`
}
/**
 * 随机生成一个可控制透明度的十六进制颜色值
 * @param {Number} opacity 透明度
 * @returns String
 */
function randomHexColor(opacity = 1) {
  return `#${['r', 'g', 'b'].map(() => Math.floor(Math.random() * (255 + 1)).toString(16)).join('')}${Math.floor(
    opacity * 255,
  ).toString(16)}`
}
/**
 * 随机生成一个可控制透明度的hls颜色值
 * @param {Number} opacity 透明度
 * @returns String
 */
function randomHlsColor(opacity = 1) {
  return `hsl(${Math.floor(Math.random() * 360)}, ${Math.floor(Math.random() * 100)}%, ${Math.floor(
    Math.random() * 100,
  )}%, ${opacity})`
}

/**
 * rgba转十六进制
 * @param {String} rgba rgba颜色值
 * @returns String
 */
function rgbaToHex(rgba) {
  const reg = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d*.?\d?)\)$/
  const [, r, g, b, a] = rgba.match(reg)
  return `#${[r, g, b]
    .map((item) => {
      const hex = Number(item).toString(16)
      return hex.length === 1 ? `0${hex}` : hex
    })
    .join('')}${Math.floor(a * 255).toString(16)}`
}
/**
 * 十六进制转rgba
 * @param {String} hex 十六进制颜色值
 * @returns String
 */
function hexToRgba(hex, opa = 0.1) {
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/
  let sColor = hex.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
      return `rgba(${(parseInt(`0x${sColor.slice(7, 9)}`) / 255).toFixed(2)},${opa})`
    }
    // 处理六位的颜色值
    const sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt(`0x${sColor.slice(i, i + 2)}`))
    }
    // return `rgba(${sColorChange.join(',')}, ${(parseInt(`0x${sColor.slice(7, 9)}`) / 255).toFixed(2)})`
    return `rgba(${sColorChange.join(',')},${opa})`
  }
}
/**
 * 十六进制转hls
 * @param {String} hex 十六进制颜色值
 * @returns String
 */
function hexToHls(hex) {
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/
  let sColor = hex.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    // 处理六位的颜色值
    const sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt(`0x${sColor.slice(i, i + 2)}`))
    }
    const r = sColorChange[0] / 255
    const g = sColorChange[1] / 255
    const b = sColorChange[2] / 255
    const max = Math.max(r, g, b)
    const min = Math.min(r, g, b)
    let h = 0
    let s = 0
    const l = (max + min) / 2
    if (max === min) {
      h = 0
      s = 0
    } else {
      const d = max - min
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0)
          break
        case g:
          h = (b - r) / d + 2
          break
        case b:
          h = (r - g) / d + 4
          break
        default:
          break
      }
      h /= 6
    }
    return `hsl(${Math.floor(h * 360)}, ${Math.floor(s * 100)}%, ${Math.floor(l * 100)}%)`
  }
}
/**
 * rgba转hls
 *  @param {String} rgba rgba颜色值
 * @returns String
 */
function rgbaToHls(rgba) {
  const reg = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d*.?\d?)\)$/
  const [, r, g, b, a] = rgba.match(reg)
  const r1 = r / 255
  const g1 = g / 255
  const b1 = b / 255
  const max = Math.max(r1, g1, b1)
  const min = Math.min(r1, g1, b1)
  let h = 0
  let s = 0
  const l = (max + min) / 2
  if (max === min) {
    h = 0
    s = 0
  } else {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) {
      case r1:
        h = (g1 - b1) / d + (g1 < b1 ? 6 : 0)
        break
      case g1:
        h = (b1 - r1) / d + 2
        break
      case b1:
        h = (r1 - g1) / d + 4
        break
      default:
        break
    }
    h /= 6
  }

  return `hsl(${Math.floor(h * 360)}, ${Math.floor(s * 100)}%, ${Math.floor(l * 100)}%)`
}
/**
 * hls转rgba
 * @param {String} hls hls颜色值
 * @returns String
 */
function hlsToRgba(hls) {
  const reg = /^hsl\((\d+),\s*(\d+),\s*(\d+)\)$/
  const [, h, s, l] = hls.match(reg)
  const h1 = h / 360
  const s1 = s / 100
  const l1 = l / 100
  let r = 0
  let g = 0
  let b = 0
  if (s1 === 0) {
    r = g = b = l1
  } else {
    const q = l1 < 0.5 ? l1 * (1 + s1) : l1 + s1 - l1 * s1
    const p = 2 * l1 - q
    r = hue2rgb(p, q, h1 + 1 / 3)
    g = hue2rgb(p, q, h1)
    b = hue2rgb(p, q, h1 - 1 / 3)
  }
  return `rgba(${Math.floor(r * 255)}, ${Math.floor(g * 255)}, ${Math.floor(b * 255)}, 1)`
}
/**
 * hls转hex
 * @param {String} hls hls颜色值
 * @returns String
 */
function hlsToHex(hls) {
  const reg = /^hsl\((\d+),\s*(\d+),\s*(\d+)\)$/
  const [, h, s, l] = hls.match(reg)
  const h1 = h / 360
  const s1 = s / 100
  const l1 = l / 100
  let r = 0
  let g = 0
  let b = 0
  if (s1 === 0) {
    r = g = b = l1
  } else {
    const q = l1 < 0.5 ? l1 * (1 + s1) : l1 + s1 - l1 * s1
    const p = 2 * l1 - q
    r = hue2rgb(p, q, h1 + 1 / 3)
    g = hue2rgb(p, q, h1)
    b = hue2rgb(p, q, h1 - 1 / 3)
  }
  const hex = `#${Math.floor(r * 255).toString(16)}${Math.floor(g * 255).toString(16)}${Math.floor(b * 255).toString(
    16,
  )}`
  return hex
}

function hexToRgb(bgColor, opacity) {
  let color = bgColor.slice(1) // 去掉'#'号
  let rgba = [
    parseInt('0x' + color.slice(0, 2)),
    parseInt('0x' + color.slice(2, 4)),
    parseInt('0x' + color.slice(4, 6)),
    opacity,
  ]
  return 'rgba(' + rgba.toString() + ')'
}
function copyUni(data) {
  uni.setClipboardData({
    data,
    success: () => {
      uni.showToast({
        title: '复制成功',
        icon: 'none',
        duration: 2000,
      })
    },
    fail: () => {
      uni.showToast({
        title: '复制失败',
        icon: 'none',
        duration: 2000,
      })
    },
  })
}

function getCssVariable(variableName) {
  const rootStyles = getComputedStyle(document.documentElement)
  return rootStyles.getPropertyValue(variableName).trim()
}

export {
  getCssVariable,
  copy,
  formatDate,
  getDecryptSm2,
  getFormErrorMsg,
  getLabel,
  getMd5Val,
  interval,
  isPromise,
  keepTwoDecimalFull,
  objToUrl,
  urlToObj,
  useEnv,
  randomRgbaColor,
  randomHexColor,
  randomHlsColor,
  rgbaToHex,
  hexToRgba,
  hexToHls,
  rgbaToHls,
  hlsToRgba,
  hlsToHex,
  hexToRgb,
  copyUni,
}
